
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'bootstrap/dist/js/bootstrap'
import React, { useEffect, useState, Suspense, useRef } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import Index from './routes/Index';
import { StrictMode } from 'react';
import LoadingBar from 'react-top-loading-bar'
import GlobalLoader from './components/GlobalLoader/GlobalLoader';

function App() {
  useEffect(() => {
    const handleKeyDown = (e) => {
      const functionKeys = ["F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "F10", "F11", "F12"];
      if (functionKeys.includes(e.key)) {
        e.preventDefault();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <GlobalLoader />
          {/* <LoadingBar
              color='#f11946'
              progress={progress}
              onLoaderFinished={() => { setProgress(0) }}
            /> */}
          <Routes>
            <Route path={'*'} element={<Index />} />
          </Routes>
          {/* <Index /> */}
        </BrowserRouter>
      </Provider>
    </StrictMode>
  );
}

export default App;
